import { useEffect } from 'react'
import { getCurrentScope as getCurrentSentryScope } from '@sentry/react'

import NavigationLayoutMUI from '@/components/layouts/NavigationLayoutMUI'
import { useMobilityTheme } from '@/components/mobility/theme/useMobilityTheme'
import { FEATURE_FLAGS } from '@/modules/featureFlags'
import { useCurrentRegion } from '@/modules/urlRouting/hooks'
import RequireLayerStore from '@/modules/urlRouting/RequireLayerStore'

/**
 * Mobility Manager uses the same nav and header as the curb products, plus two
 * things of its own: its pages read the region's layers, which must be loaded
 * first, and it tags Sentry with the region and the UI theme.
 */
const MobilityNavigationLayout = () => {
  const {
    data: { regionId },
  } = useCurrentRegion()

  useEffect(() => {
    getCurrentSentryScope().setTag('region', regionId)
  }, [regionId])

  // Lets us split errors by the old and the new UI while the `mobility_theme` flag is rolled out.
  // This also starts the feature flags request before a page needs it.
  const { isEnabled: hasMobilityTheme, isPending: mobilityThemePending } = useMobilityTheme()
  useEffect(() => {
    if (mobilityThemePending) return
    getCurrentSentryScope().setTag(FEATURE_FLAGS.MOBILITY_THEME, hasMobilityTheme ? 'on' : 'off')
  }, [hasMobilityTheme, mobilityThemePending])

  return (
    <RequireLayerStore>
      <NavigationLayoutMUI />
    </RequireLayerStore>
  )
}

export default MobilityNavigationLayout
